<!-- [ngClass]="{ 'mat-form-field-invalid': isControlInvalid }" -->
<mat-form-field id="date-range-picker" appearance="outline" class="tight-input w-100" subscriptSizing="dynamic">
  <mat-date-range-input
    class="mt-[2px]"
    [rangePicker]="rangePicker"
    [min]="dateRangePickerConfig.minDate ?? ''"
    [max]="dateRangePickerConfig.maxDate ?? ''"
    [disabled]="isDisabled"
  >
    <input
      matStartDate
      [(ngModel)]="startDate"
      [placeholder]="dateRangePickerConfig.startDatePlaceholder || 'Start date'"
      [ngModelOptions]="{ standalone: true }"
      [readonly]="dateRangePickerConfig.disabledDateInput"
    />
    <input
      matEndDate
      [(ngModel)]="endDate"
      [placeholder]="dateRangePickerConfig.endDatePlaceholder || 'End date'"
      [ngModelOptions]="{ standalone: true }"
      [readonly]="dateRangePickerConfig.disabledDateInput"
    />
  </mat-date-range-input>
  <mat-datepicker-toggle matIconSuffix [for]="rangePicker" [disabled]="isDisabled"></mat-datepicker-toggle>
  <mat-date-range-picker [touchUi]="dateRangePickerConfig.touchUI" #rangePicker [disabled]="isDisabled">
    <mat-date-range-picker-actions>
      <div class="time-picker-container row m-0" *ngIf="dateRangePickerConfig.showTime">
        <div class="time-picker-row col-6 p-x-4">
          <mat-form-field appearance="outline" class="time-input">
            <span class="custom-label">{{ dateRangePickerConfig.startTimePlaceholder || 'Start time' }}</span>
            <input
              matInput
              [(ngModel)]="startTime"
              (ngModelChange)="onStartTimeChange($event)"
              [placeholder]="dateRangePickerConfig.startTimePlaceholder || 'Start time'"
              pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
              #startTimeInput="ngModel"
              [format]="24"
              [ngxTimepicker]="startTimepicker"
              [disableClick]="true"
              [readonly]="dateRangePickerConfig.disabledTimeInput"
            />
            <mat-icon matSuffix (click)="startTimepicker.open()" class="time-picker-icon" *ngIf="!dateRangePickerConfig.disabledTimeInput">
              access_time
            </mat-icon>
            <mat-error *ngIf="startTimeInput.errors?.['pattern']">Please enter a valid time (HH:mm)</mat-error>
          </mat-form-field>
        </div>
        <div class="time-picker-row col-6 p-x-4">
          <mat-form-field appearance="outline" class="time-input">
            <span class="custom-label">{{ dateRangePickerConfig.endTimePlaceholder || 'End time' }}</span>
            <input
              matInput
              [(ngModel)]="endTime"
              (ngModelChange)="onEndTimeChange($event)"
              [placeholder]="dateRangePickerConfig.endTimePlaceholder || 'End time'"
              pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
              #endTimeInput="ngModel"
              [format]="24"
              [ngxTimepicker]="endTimepicker"
              [disableClick]="true"
              [readonly]="dateRangePickerConfig.disabledTimeInput"
            />
            <mat-icon matSuffix (click)="endTimepicker.open()" class="time-picker-icon">access_time</mat-icon>
            <mat-error *ngIf="endTimeInput.errors?.['pattern']">Please enter a valid time (HH:mm)</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="d-flex gap-2" [ngClass]="{ 'm-t-12': dateRangePickerConfig.showTime }">
        <button matButton="outlined" matDateRangePickerCancel>Cancel</button>
        <button matButton="filled" color="primary" (click)="onApply()" matDateRangePickerApply>Apply</button>
      </div>
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
</mat-form-field>